<template>
  <b-card
    v-b-tooltip="tooltip"
    class="mh-100 info-card-content-panel"
    :class="cardClasses"
    :body-class="cardBodyClasses"
  >
    <TipTap
      class="min-w-100 min-h-100 d-flex justify-content-center align-items-center"
      :class="contentClasses"
      :content="contentPanel.content"
      :editable="false"
      :style-settings="contentStyleSettings"
      iframe-extension
      image-extension
    />
    <b-link
      v-if="showLink"
      class="stretched-link"
      :href="getLink(infoCardContentPanelLinkTypes.EXTERNAL)"
      :to="getLink(infoCardContentPanelLinkTypes.INTERNAL)"
      :target="linkTarget"
      data-test="link"
    />
  </b-card>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import TipTap from '@/components/TipTap/TipTap.vue'
import { InfoCardContentPanel as InfoCardContentPanelType, InfoCardContentPanelLinkType, InfoCardContentPanelLinkTypes } from '@/types'

const components = {
  TipTap,
}

const props = {
  contentPanel: Object as () => InfoCardContentPanelType,
  fill: Boolean,
}

@Component({ components })
export default class InfoCardContentPanel extends Vue.extend({ props }) {
  infoCardContentPanelLinkTypes = InfoCardContentPanelLinkTypes

  get contentStyleSettings () {
    return {
      fontSize: 100,
    }
  }

  get cardClasses () {
    return {
      'border-0': this.contentPanel.hideBorder,
    }
  }

  get cardBodyClasses () {
    return {
      'p-0': this.contentPanel.hideBorder,
    }
  }

  get contentClasses () {
    return this.fill ? ['h-100', 'mh-100', 'fill'] : []
  }

  get tooltip () {
    return {
      customClass: 'content-panel-tooltip',
      show: !!this.contentPanel.tooltip,
      title: this.contentPanel.tooltip,
      placement: 'top',
      trigger: 'hover',
      boundary: 'viewport',
    }
  }

  get showLink () {
    return this.contentPanel.linkType && this.contentPanel.link
  }

  getLink (linkType: InfoCardContentPanelLinkType) {
    if (this.contentPanel.linkType === linkType) {
      return this.contentPanel.link
    }
  }

  get linkTarget () {
    if (this.contentPanel.linkType === InfoCardContentPanelLinkTypes.EXTERNAL) {
      return '_blank'
    } else {
      return '_self'
    }
  }
}

</script>

<style scoped>

.info-card-content-panel {
  background: none;
  min-height: 200px;
}

.info-card-content-panel >>> .editor__content {
  flex-grow: 1;
}

.fill >>> div {
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

</style>

<style>

.content-panel-tooltip .tooltip-inner {
  white-space: pre-wrap;
}

</style>
